import { Helmet } from 'react-helmet-async';

import config from '../../config';
import {
  DigestHighlightsSlice,
  HeroSlice,
  MetadataSlice,
  SliceType,
  isSliceOfType,
} from '../../slices';
import { getRelatedBreedLinks } from '../../slices/DigestHighlightsSlice/utils';
import { useRoutes } from '../../static-context';

import { BuildYourPlan } from './BuildYourPlan';
import { createBreedSchema } from './createBreedSchema';
import { CustomerReviews } from './CustomerReviews';
import { FreshDogFood } from './FreshDogFood';
import { prepareBreedSchemaData } from './prepareBreedSchemaData';
import { WhyFreshIsBest } from './WhyFreshIsBest';

import type { BreedDocument } from './types';

export interface BreedContentTypeProps {
  document: BreedDocument;
}

export function BreedContentType({ document }: BreedContentTypeProps) {
  const { body } = document.data;
  const breed = document.data.title;

  const heroSlice = body.find(isSliceOfType(SliceType.HeroSlice));
  const metadataSlice = body.find(isSliceOfType(SliceType.MetadataSlice));
  const digestSlice = body.find(isSliceOfType(SliceType.DigestHighlightsSlice));

  const allRoutes = useRoutes();
  const baseUrl = config.get('app.websiteUrl');
  const relatedBreedLinks = getRelatedBreedLinks({
    allRoutes,
    buildId: document.buildId,
  });
  const schema = createBreedSchema(
    prepareBreedSchemaData({ document, relatedBreedLinks, baseUrl })
  );

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      {metadataSlice && <MetadataSlice slice={metadataSlice} />}
      {heroSlice && <HeroSlice slice={heroSlice} />}
      <FreshDogFood document={document} />
      <WhyFreshIsBest breed={breed} />
      <BuildYourPlan document={document} breed={breed} />
      <CustomerReviews />
      <DigestHighlightsSlice
        slice={digestSlice}
        breed={breed}
        buildId={document.buildId}
        breedLinks={relatedBreedLinks}
      />
    </>
  );
}
